/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Faint_Hawk_PlotInputs */

const en_green_faint_hawk_plot = /** @type {(inputs: Green_Faint_Hawk_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared to`)
};

const de_green_faint_hawk_plot = /** @type {(inputs: Green_Faint_Hawk_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigegeben für`)
};

/**
* | output |
* | --- |
* | "Shared to" |
*
* @param {Green_Faint_Hawk_PlotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_faint_hawk_plot = /** @type {((inputs?: Green_Faint_Hawk_PlotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Faint_Hawk_PlotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_faint_hawk_plot(inputs)
	return de_green_faint_hawk_plot(inputs)
});